(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-design-browser"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('st-design-browser'))customElements.define('st-design-browser',class extends HTMLElement{
  connectedCallback(){
    this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
    try{this.rows=JSON.parse(this.querySelector('[data-browser-data]').textContent);}catch{return;}
    this.cards=[...this.querySelectorAll('[data-browser-card]')];this.buttons=[...this.querySelectorAll('[data-browser-color]')];
    const linked=new Set(this.rows.map(row=>row.series));
    this.buttons.forEach(button=>{
      button.disabled=this.rows.filter(row=>row.color===button.dataset.browserColor).length!==linked.size||!linked.size;
      button.addEventListener('click',()=>{this.choose(button.dataset.browserColor);this.querySelector('details').open=false;this.querySelector('summary').focus({preventScroll:true});},{signal});
      button.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key))return;
        event.preventDefault();const choices=this.buttons.filter(choice=>!choice.disabled),current=choices.indexOf(button),step=['ArrowLeft','ArrowUp'].includes(event.key)?-1:1;
        const next=event.key==='Home'?0:event.key==='End'?choices.length-1:(current+step+choices.length)%choices.length;
        this.choose(choices[next].dataset.browserColor);choices[next].focus();
      },{signal});
    });
    this.querySelector('[data-browser-tools]').hidden=!linked.size;
    const initial=new URL(location.href).searchParams.get('st_color');if(initial)this.choose(initial,false);
    window.addEventListener('popstate',()=>this.choose(new URL(location.href).searchParams.get('st_color')||'forest',false),{signal});
  }
  choose(color,update=true){
    const button=this.buttons.find(item=>item.dataset.browserColor===color);if(!button||button.disabled)return;
    this.rows.filter(row=>row.color===color).forEach(row=>{
      const card=this.cards.find(item=>item.dataset.browserCard===row.series);if(!card)return;
      const image=card.querySelector('img');const url=new URL(row.image,location.href);
      image.srcset=[200,360,540,800].map(width=>{const src=new URL(url);src.searchParams.set('width',String(width));return `${src.href} ${width}w`;}).join(', ');
      image.src=url.href;image.alt=row.name;card.querySelector('[data-browser-link]').href=row.url;card.querySelector('[data-browser-name]').textContent=row.name;card.querySelector('[data-browser-price]').textContent=row.price;
    });
    this.buttons.forEach(item=>{const selected=item===button;item.setAttribute('aria-checked',String(selected));item.tabIndex=selected?0:-1;});
    const label=button.textContent.trim();this.querySelector('[data-browser-current]').textContent=label;this.querySelector('[data-browser-status]').textContent=this.dataset.statusTemplate.replace('__COLOR__',label);
    if(update){const url=new URL(location.href);url.searchParams.set('st_color',color);history.replaceState(history.state,'',url);}
  }
  disconnectedCallback(){this.controller?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-sakura-showroom"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sakura-showroom')) {
  customElements.define('sakura-showroom', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const button = event.target.closest('.ss__swatch');
        if (!button || !this.contains(button)) return;
        const art = this.querySelector('.ss__art');
        const shop = this.querySelector('[data-ss-shop]');
        if (!art || !shop) return;
        for (const swatch of this.querySelectorAll('.ss__swatch')) {
          swatch.setAttribute('aria-pressed', String(swatch === button));
        }
        art.srcset = button.dataset.srcset || '';
        art.src = button.dataset.image;
        art.alt = button.dataset.name;
        this.querySelector('.ss__selected [data-name]').textContent = button.dataset.name;
        this.querySelector('.ss__selected [data-palette]').textContent = button.dataset.palette;
        this.querySelector('[data-ss-price]').textContent = button.dataset.price;
        this.querySelector('.ss__price').hidden = !button.dataset.product;
        shop.hidden = !button.dataset.product;
        if (button.dataset.product) shop.href = button.dataset.product;
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["surfacetheory-hero"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('surface-showroom')) {
  customElements.define('surface-showroom', class extends HTMLElement {
    connectedCallback() {
      this.clearSelectionLight();
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
      this.stage = this.querySelector('[data-st-display]');
      this.angle = this.querySelector('[data-st-angle]');
      this.art = this.querySelector('.st-artwork');
      this.motion = this.querySelector('[data-st-motion]');
      this.motionLabel = this.querySelector('[data-st-motion-label]');
      this.series = Array.from(this.querySelectorAll('[data-series-source]'));
      this.all = this.querySelector('[data-show-all]');
      if (!this.stage || !this.angle || !this.motion || !this.motionLabel) return;
      this.motion.hidden = false;
      this.motion.addEventListener('click', () => {
        const paused = this.dataset.paused !== 'true';
        this.dataset.paused = String(paused);
        if (paused) {
          cancelAnimationFrame(this.frame);
          this.angle.getAnimations().forEach(animation => animation.finish());
        }
        this.motion.setAttribute('aria-pressed', String(paused));
        this.motionLabel.textContent = paused ? this.motionLabel.dataset.resume : this.motionLabel.dataset.pause;
      }, {signal});
      if (navigator.connection?.saveData && this.dataset.paused !== 'true') this.motion.click();
      const reset = () => {
        cancelAnimationFrame(this.frame);
        this.activePointer = null;
        this.angle.style.removeProperty('--st-rx');
        this.angle.style.removeProperty('--st-ry');
        this.angle.style.removeProperty('--st-light-x');
        this.angle.style.removeProperty('--st-light-y');
      };
      this.stage.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' && event.isPrimary && event.target.closest('.st-mat-float')) this.activePointer = event.pointerId;
      }, {signal});
      this.reduce.addEventListener('change', () => {
        reset();
        this.angle.getAnimations().forEach(animation => animation.finish());
      }, {signal});
      this.stage.addEventListener('pointermove', event => {
        if (this.reduce.matches || this.busy || this.dataset.paused === 'true' || (event.pointerType !== 'mouse' && event.pointerId !== this.activePointer)) return;
        const bounds = this.stage.getBoundingClientRect();
        if (!bounds.width || !bounds.height) return;
        const x = Math.max(-1, Math.min(1, ((event.clientX - bounds.left) / bounds.width - .5) * 2));
        const y = Math.max(-1, Math.min(1, ((event.clientY - bounds.top) / bounds.height - .5) * 2));
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.angle.style.setProperty('--st-ry', `${x * 5}deg`);
          this.angle.style.setProperty('--st-rx', `${y * -3}deg`);
          this.angle.style.setProperty('--st-light-x', `${32 + x * 8}%`);
          this.angle.style.setProperty('--st-light-y', `${18 + y * 6}%`);
        });
      }, {signal});
      ['pointerleave','pointerup','pointercancel'].forEach(type => this.stage.addEventListener(type, reset, {signal}));
      this.gallery = this.querySelector('[data-orbit]');
      this.orbitStage = this.querySelector('[data-orbit-stage]');
      this.items = this.series.map(card => card.closest('.st-orbit-item'));
      this.all = this.querySelector('[data-show-all]');
      this.back = this.querySelector('[data-orbit-back]');
      this.detail = this.querySelector('[data-orbit-detail]');
      this.index = this.querySelector('[data-orbit-index]');
      this.initLookbook(signal);
      this.position = 0;
      this.activeSeries = 0;
      this.focused = false;
      this.cache = new Map();
      this.loadTimers = new Set();
      this.selectionVersion = 0;
      this.tabs = [];
      if (!this.gallery || !this.series.length) return;
      this.series.forEach((card, i) => {
        const material = this.querySelector('[data-index-material]')?.content.cloneNode(true);
        if (material) {
          card.querySelectorAll('.st-photo-edge,.st-photo-weave').forEach(layer => layer.remove());
          card.querySelector('.st-orbit-surface').append(material);
        }
        card.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (performance.now() < (this.suppressClickUntil || 0)) return;
          this.focusSeries(i, card);
        }, {signal});
        card.addEventListener('pointerenter', () => this.warm(i), {signal});
        card.addEventListener('focus', () => this.warm(i), {signal});
        const tile = document.createElement('article');
        tile.className = 'st-index-card';
        tile.toggleAttribute('data-purchasable',Boolean(card.dataset.productLink));
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'st-orbit-tab';
        button.setAttribute('aria-label', this.dataset.indexPreviewAction + ': ' + card.dataset.matName + ', ' + card.dataset.seriesName);
        button.setAttribute('aria-pressed', 'false');
        const thumb = document.createElement('img');
        thumb.src = card.dataset.preview;
        thumb.alt = '';
        thumb.width = 600;
        thumb.height = Math.round(600 / (Number(card.dataset.ratio) || 2));
        thumb.loading = 'lazy';
        thumb.decoding = 'async';
        thumb.draggable = false;
        const meta = document.createElement('span');
        meta.className = 'st-orbit-tab__meta';
        const number = document.createElement('span');
        number.className = 'st-orbit-tab__number';
        number.textContent = String(i + 1).padStart(2, '0');
        const short = document.createElement('span');
        short.className = 'st-orbit-tab__short';
        short.textContent = card.dataset.seriesName.replace(/^Core (?!Series)/,'').replace(/ Series$/,'');
        button.title = card.dataset.seriesName;
        const name = document.createElement('span');
        name.className = 'st-orbit-tab__name';
        name.textContent = card.dataset.seriesName;
        const artName = document.createElement('span');
        artName.className = 'st-orbit-tab__art';
        artName.textContent = card.dataset.matName;
        meta.append(name, artName);
        const top = document.createElement('span');
        top.className = 'st-index-card__top';
        const availability = document.createElement('span');
        availability.className = 'st-index-card__availability';
        availability.textContent = card.dataset.productLink ? card.dataset.available === 'true' ? this.dataset.indexAvailable : this.dataset.indexUnavailable : this.dataset.indexPreview;
        top.append(number, availability);
        const chamber = document.createElement('span');
        chamber.className = 'st-index-card__chamber';
        const selected = document.createElement('span');
        selected.className = 'st-index-card__selected';
        selected.textContent = this.dataset.indexSelected;
        selected.setAttribute('aria-hidden','true');
        const scene = document.createElement('span');
        scene.className = 'st-orbit-tab__scene';
        scene.style.setProperty('--st-card-ratio', card.dataset.ratio || '2');
        const surface = document.createElement('span');
        surface.className = 'st-index-fabric';
        surface.append(thumb);
        const seam = this.querySelector('[data-index-material]')?.content.cloneNode(true);
        scene.append(surface);
        if (seam) scene.append(seam);
        chamber.append(scene, selected);
        const previewAction = document.createElement('span');
        previewAction.className = 'st-index-card__preview';
        previewAction.textContent = this.dataset.indexPreviewAction;
        const arrow = document.createElement('span');
        arrow.textContent = '↗';
        arrow.setAttribute('aria-hidden','true');
        previewAction.append(arrow);
        button.append(top, chamber, meta, previewAction);
        tile.append(button);
        if (card.dataset.productLink) {
          const commerce = document.createElement('div');
          commerce.className = 'st-index-card__commerce';
          const price = document.createElement('span');
          price.className = 'st-index-card__price';
          price.textContent = card.dataset.price || '';
          const sizes = document.createElement('small');
          sizes.textContent = card.dataset.sizeCount || '';
          price.append(sizes);
          const shop = document.createElement('a');
          shop.className = 'st-index-card__shop';
          shop.href = card.dataset.productLink;
          shop.textContent = this.dataset.indexShopAction;
          shop.setAttribute('aria-label',this.dataset.indexShopAction + ': ' + card.dataset.matName);
          const icon = document.createElement('span');
          icon.textContent = '↗';
          icon.setAttribute('aria-hidden','true');
          shop.append(icon);
          commerce.append(price,shop);
          tile.append(commerce);
        }
        if (card.dataset.collectionLink) {
          const collectionLink = document.createElement('a');
          collectionLink.className = 'st-index-family-link';
          collectionLink.href = card.dataset.collectionLink;
          collectionLink.textContent = this.dataset.exploreColors;
          collectionLink.setAttribute('aria-label',this.dataset.exploreColors + ': ' + card.dataset.seriesName);
          const arrow = document.createElement('span');
          arrow.textContent = '↗';
          arrow.setAttribute('aria-hidden','true');
          collectionLink.append(arrow);
          tile.append(collectionLink);
        }
        button.addEventListener('click', () => this.focusSeries(i, button), {signal});
        button.addEventListener('pointerenter', () => this.warm(i), {signal});
        button.addEventListener('focus', () => this.warm(i), {signal});
        this.index.append(tile);
        this.tabs.push(button);
        const preview = card.querySelector('img');
        preview.addEventListener('error', () => {
          card.dataset.failed = 'true';
          if (this.activeSeries === i && this.focused) this.showImageError(true);
        }, {signal});
        preview.addEventListener('load', () => {
          delete card.dataset.failed;
          if (this.activeSeries === i) this.showImageError(false);
        }, {signal});
      });
      this.gallery.setAttribute('data-enhanced', '');
      this.all.hidden = false;
      this.back.hidden = false;
      this.querySelector('[data-orbit-nav]').hidden = false;
      this.querySelector('[data-orbit-caption]').hidden = false;
      this.querySelector('[data-directory-panel]').hidden = false;
      this.all.addEventListener('click', () => {
        this.cancelDeployment?.();
        this.tabs.forEach(tab => {const image=tab.querySelector('img');image.loading='eager';image.decode?.().catch(() => {});});
        const panel = this.querySelector('[data-directory-panel]');
        panel.scrollIntoView({block:'start',behavior:this.reduce.matches ? 'instant' : 'smooth'});
        this.tabs[this.activeSeries].focus({preventScroll:true});
      }, {signal});
      this.back.addEventListener('click', () => this.returnToBrowse(), {signal});
      this.querySelector('[data-orbit-prev]').addEventListener('click', () => this.browse(-1), {signal});
      this.querySelector('[data-orbit-next]').addEventListener('click', () => this.browse(1), {signal});
      this.querySelector('[data-orbit-retry]').addEventListener('click', () => {
        const card = this.series[this.activeSeries];
        this.cache.delete(card.dataset.preview);
        this.load(card.dataset.preview).then(image => {
          if (!image || !this.isConnected) return;
          card.querySelector('img').src = image.src;
          delete card.dataset.failed;
          this.showImageError(false);
          if (this.series[this.activeSeries] === card) this.syncHero(card);
        });
      }, {signal});
      this.gallery.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          if (this.focused) { event.preventDefault(); this.returnToBrowse(); }
          return;
        }
        if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
        const tabIndex = this.tabs.indexOf(event.target.closest('.st-orbit-tab'));
        const cardIndex = this.series.indexOf(event.target.closest('[data-series-source]'));
        if (tabIndex < 0 && cardIndex < 0) return;
        if (cardIndex >= 0 && ['ArrowUp','ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        const current = tabIndex >= 0 ? tabIndex : cardIndex;
        const columns = getComputedStyle(this.index).gridTemplateColumns.split(' ').length;
        const stride = event.key === 'ArrowDown' ? columns : event.key === 'ArrowUp' ? -columns : event.key === 'ArrowRight' ? 1 : -1;
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? this.series.length - 1 : (current + stride + this.series.length) % this.series.length;
        if (tabIndex >= 0) {
          this.tabs[next].focus({preventScroll:true});
          this.tabs[next].scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
        } else {
          this.focused = false;
          this.position = next;
          this.paint();
          this.series[next].focus({preventScroll:true});
        }
      }, {signal});
      this.orbitStage.addEventListener('pointerdown', event => {
        if (this.focused || !event.isPrimary || event.button !== 0 || event.target.closest('button')) return;
        this.drag = {id:event.pointerId,x:event.clientX,y:event.clientY,start:this.position,moved:false};
      }, {signal});
      this.orbitStage.addEventListener('pointermove', event => {
        const drag = this.drag;
        if (!drag || drag.id !== event.pointerId) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.moved && Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) { this.drag = null; return; }
        if (!drag.moved && Math.abs(dx) < 8) return;
        if (!drag.moved) {
          drag.moved = true;
          this.orbitStage.setPointerCapture(event.pointerId);
          this.gallery.setAttribute('data-dragging', '');
        }
        this.position = drag.start - dx / (this.orbitStage.clientWidth * (this.mobile ? .5 : .24));
        cancelAnimationFrame(this.orbitFrame);
        this.orbitFrame = requestAnimationFrame(() => this.paint(false));
      }, {signal});
      const endDrag = event => {
        if (event.type === 'lostpointercapture' && event.target !== this.orbitStage) return;
        if (!this.drag || event.pointerId !== this.drag.id) return;
        if (this.drag.moved) {
          cancelAnimationFrame(this.orbitFrame);
          this.position = Math.round(this.position);
          this.suppressClickUntil = performance.now() + 250;
          this.gallery.removeAttribute('data-dragging');
          this.warm(this.mod(Math.round(this.position)));
          if (this.orbitStage.hasPointerCapture(event.pointerId)) this.orbitStage.releasePointerCapture(event.pointerId);
          this.paint();
        }
        this.drag = null;
      };
      ['pointerup','pointercancel','lostpointercapture'].forEach(type => this.orbitStage.addEventListener(type, endDrag, {signal}));
      this.orbitStage.addEventListener('dragstart', event => event.preventDefault(), {signal});
      this.orbitStage.addEventListener('wheel', event => {
        if (this.focused || Math.abs(event.deltaX) < Math.abs(event.deltaY) || Math.abs(event.deltaX) < 4) return;
        event.preventDefault();
        if (performance.now() - (this.lastWheel || 0) < 220) return;
        this.lastWheel = performance.now();
        this.browse(event.deltaX > 0 ? 1 : -1);
      }, {signal,passive:false});
      this.querySelectorAll('a[href^="#"],[data-st-cta]').forEach(link => link.addEventListener('click', event => {
        if (link.matches('[data-series-source]') || link.getAttribute('href') !== this.dataset.galleryDestination || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.openCollection(link);
      }, {signal}));
      this.querySelectorAll('[data-open-collection],[data-st-cta],.st-explore-link').forEach(link => {
        ['pointerenter','focus','pointerdown'].forEach(type => link.addEventListener(type, () => this.prepareEntrance(), {signal,passive:true}));
      });
      const sizes = document.querySelector('surface-proportions');
      if (sizes) {
        if (!sizes.id) sizes.id = this.id ? `${this.id}-sizes` : `${this.gallery.id}-sizes`;
        this.sizesDestination = '#' + sizes.id;
        this.querySelector('[data-detail-link]').href = this.sizesDestination;
      }
      this.motion.addEventListener('click', () => { this.cancelDeployment?.(true); this.clearSelectionLight(); }, {signal});
      this.reduce.addEventListener('change', () => { if (this.reduce.matches) { this.cancelDeployment?.(true); this.clearSelectionLight(); } }, {signal});
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.clearSelectionLight(); }, {signal});
      this.galleryObserver = new IntersectionObserver(entries => {
        this.gallery.toggleAttribute('data-offscreen', !entries[0].isIntersecting);
        if (!entries[0].isIntersecting) this.clearSelectionLight();
        else this.warm(this.mod(Math.round(this.position)));
      });
      this.galleryObserver.observe(this.orbitStage);
      this.resizeObserver = new ResizeObserver(() => { if (!this.deploying) this.paint(false); });
      this.resizeObserver.observe(this.orbitStage);
      this.initPalette(signal);
      this.paint(false);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => this.toggleAttribute('data-offscreen', !entries[0].isIntersecting));
        this.observer.observe(this.stage);
        this.previewObserver = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.series.forEach(card => card.querySelector('img').loading = 'eager');
          this.previewObserver.disconnect();
        }, {rootMargin:'600px'});
        this.previewObserver.observe(this.gallery);
      }
    }
    scrollOwner(target = this.gallery) {
      // Horizon scrolls .page-wrapper on desktop and the document below 990px.
      // Discover the owner rather than binding this component to that breakpoint.
      for (let parent = target.parentElement; parent && parent !== document.body; parent = parent.parentElement) {
        if (/(auto|scroll)/.test(getComputedStyle(parent).overflowY) && parent.scrollHeight > parent.clientHeight + 1) return parent;
      }
      return document.scrollingElement || document.documentElement;
    }
    collectionScroll(target = this.gallery) {
      const owner = this.scrollOwner(target);
      const documentScroll = owner === document.scrollingElement;
      const top = documentScroll ? 0 : owner.getBoundingClientRect().top + owner.clientTop;
      const height = documentScroll ? innerHeight : owner.clientHeight;
      const margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
      return {owner, destination:Math.max(0,Math.min(owner.scrollHeight-height,owner.scrollTop+target.getBoundingClientRect().top-top-margin))};
    }
    landInCollection(focus = true) {
      if (!this.isConnected) return;
      // Re-measure at arrival: editor chrome, sticky headers and responsive changes
      // must not leave navigation dependent on the animation's old measurements.
      const {owner,destination} = this.collectionScroll();
      owner.scrollTo({top:destination,behavior:'instant'});
      const offset = this.gallery.getBoundingClientRect().top - (owner === document.scrollingElement ? 0 : owner.getBoundingClientRect().top + owner.clientTop);
      const margin = parseFloat(getComputedStyle(this.gallery).scrollMarginTop) || 0;
      if (Math.abs(offset-margin) > 3) this.gallery.scrollIntoView({block:'start',inline:'nearest',behavior:'instant'});
      if (focus) {
        const heading = this.gallery.querySelector('h2');
        heading.setAttribute('tabindex','-1');
        heading.focus({preventScroll:true});
      }
    }
    prepareEntrance() {
      this.series.forEach(card => {
        const image = card.querySelector('.st-orbit-image');
        image.loading = 'eager';
        image.decode?.().catch(() => {});
      });

      const room = this.querySelector('.st-vault-room');
      if (room) room.loading = 'eager';
    }
    openCollection(trigger) {
      if (this.deploying) { this.cancelDeployment?.(true); return; }
      this.clearSelectionLight();
      this.gallery.setAttribute('data-deploy-settled','');
      this.focused = false;
      this.position = this.activeSeries;
      this.showImageError(false);
      this.paint(false);
      this.prepareEntrance();
      if (this.reduce.matches || this.dataset.paused === 'true') {
        this.gallery.removeAttribute('data-deploy-settled');
        this.landInCollection();
        return;
      }
      const {owner,destination} = this.collectionScroll();
      const origin = owner.scrollTop;
      const distance = destination-origin;
      const source = this.querySelector('.st-mat-float').getBoundingClientRect();
      const sourcePoint = {x:source.left+source.width/2,y:source.top+source.height/2};
      const sourceWidth = this.angle.offsetWidth;
      const sourceTransform = getComputedStyle(this.angle).transform;
      const sourceMatrix = new DOMMatrix(sourceTransform);
      const sourcePitch = Math.atan2(-sourceMatrix.m32,sourceMatrix.m33)*180/Math.PI;
      const sourceYaw = Math.asin(Math.max(-1,Math.min(1,sourceMatrix.m31)))*180/Math.PI;
      const mobile = innerWidth < 750;
      const stageRect = this.orbitStage.getBoundingClientRect();
      const stageCenter = stageRect.top-distance+stageRect.height/2;
      const layer = document.createElement('div');
      layer.className = 'st-showroom st-deploy-layer st-transit st-transit--atelier';
      layer.setAttribute('aria-hidden','true');
      layer.inert = true;
      const make = (name,parent=layer) => {const element=document.createElement('div');element.className=name;parent.append(element);return element;};
      const darkness = make('st-transit-darkness');
      const space = this.querySelector('.st-orbit-architecture').cloneNode(true);
      space.className = 'st-transit-space';
      space.style.cssText = `left:${stageRect.left}px;top:${stageRect.top-distance}px;width:${stageRect.width}px;height:${stageRect.height}px`;
      const room = space.querySelector('.st-vault-room');
      if (room) {room.loading='eager';room.removeAttribute('srcset');room.src=this.querySelector('.st-vault-room').currentSrc || room.src;room.style.filter=getComputedStyle(this.querySelector('.st-vault-room')).filter;}
      layer.append(space);
      const halo = make('st-transit-halo');
      const structures = [make('st-transit-frame st-transit-frame--outer')];
      structures.forEach(frame => {make('st-transit-frame__edge',frame);make('st-transit-frame__floor',frame);});
      const doors = [];
      doors.forEach(door => {make('st-transit-door__rail',door);make('st-transit-door__inset',door);});
      const seam = make('st-transit-seam');
      const horizon = make('st-transit-horizon');
      const title = make('st-transit-title');
      title.textContent = this.querySelector('.st-orbit-heading h2').textContent;
      const tiles = [];
      const columns = mobile?3:6;
      const rows = Math.ceil(this.series.length/columns);
      const spreadWidth = Math.min(innerWidth*(mobile?.252:.139),230);
      const spacingX = spreadWidth*(mobile?1.17:1.16);
      const spacingY = spreadWidth*(mobile?.72:.9);
      const centerSlot = Math.floor(rows/2)*columns+Math.floor(columns/2);
      const planeY = innerHeight*(mobile?.45:.48);
      this.gallery.setAttribute('data-deploying','');
      this.series.forEach((card,i) => {
        const chosen = i===this.activeSeries;
        const item = this.items[i];
        const float = card.querySelector('.st-orbit-float');
        const rect = float.getBoundingClientRect();
        const width = item.offsetWidth;
        const rank = ((i-this.activeSeries+this.series.length*2+this.series.length/2)%this.series.length)-this.series.length/2;
        const slot = (i-this.activeSeries+centerSlot+this.series.length)%this.series.length;
        const rowCount = Math.min(columns, this.series.length - Math.floor(slot/columns)*columns);
        const column = slot%columns-(rowCount-1)/2;
        const row = Math.floor(slot/columns)-(rows-1)/2;
        const tile = make('st-deploy-tile');
        tile.style.width=width+'px';
        tile.style.height=width/(Number(card.dataset.ratio)||2)+'px';
        tile.style.zIndex=String(chosen?40:30-Math.round(Math.abs(rank)));
        const shadow = make('st-transit-shadow',tile);
        const object = card.querySelector('.st-orbit-object').cloneNode(true);
        object.querySelector('.st-orbit-trace')?.replaceChildren();
        const image = object.querySelector('.st-orbit-image');
        image.loading='eager';
        image.decoding='sync';
        image.removeAttribute('srcset');
        image.src=card.querySelector('.st-orbit-image').currentSrc || image.src;
        if (chosen && this.art.complete && this.art.naturalWidth) {image.removeAttribute('srcset');image.src=this.art.currentSrc || this.art.src;}
        tile.append(object);
        const beam = make('st-transit-material-light',object.querySelector('.st-orbit-surface'));
        tiles.push({tile,object,image,shadow,beam,width,rank,chosen,slot,column,row,
          gx:innerWidth*.5+column*spacingX,
          gy:planeY+row*spacingY-Math.abs(column)*(mobile?5:14),
          x:rect.left+rect.width/2,y:rect.top+rect.height/2,
          scale:parseFloat(item.style.getPropertyValue('--orbit-scale')),
          opacity:parseFloat(item.style.getPropertyValue('--orbit-opacity')),
          rx:parseFloat(item.style.getPropertyValue('--orbit-rx')),
          ry:parseFloat(item.style.getPropertyValue('--orbit-ry')),
          rz:parseFloat(item.style.getPropertyValue('--orbit-rz'))});
      });
      document.body.append(layer);
      this.deploying=true;
      this.deployController=new AbortController();
      const signal=this.deployController.signal;
      this.setAttribute('data-deploying','');
      this.gallery.removeAttribute('data-deploy-settled');
      trigger?.setAttribute('aria-busy','true');
      let finished=false;
      this.cancelDeployment=(arrive=false) => {
        if (finished) return;
        finished=true;
        cancelAnimationFrame(this.deployFrame);
        this.deployController.abort();
        this.gallery.setAttribute('data-deploy-settled','');
        this.gallery.removeAttribute('data-deploying');
        this.gallery.style.removeProperty('--arrival-labels');
        this.removeAttribute('data-deploying');
        trigger?.removeAttribute('aria-busy');
        layer.remove();
        this.deploying=false;
        this.cancelDeployment=null;
        cancelAnimationFrame(this.settleFrame);
        this.settleFrame=requestAnimationFrame(()=>this.gallery.removeAttribute('data-deploy-settled'));
        if (arrive) this.landInCollection();
      };
      const initialWidth=innerWidth;
      window.addEventListener('resize',()=>{if(innerWidth!==initialWidth)this.cancelDeployment?.(true);},{signal});
      window.addEventListener('wheel',()=>this.cancelDeployment?.(),{passive:true,signal});
      window.addEventListener('touchstart',()=>this.cancelDeployment?.(true),{passive:true,signal});
      window.addEventListener('pointerdown',event=>{if(!event.target.closest('[data-open-collection],[data-st-cta],.st-explore-link'))this.cancelDeployment?.(true);},{signal});
      window.addEventListener('keydown',event=>{if(['Escape','Tab','PageUp','PageDown','ArrowUp','ArrowDown','Home','End'].includes(event.key))this.cancelDeployment?.();},{signal});
      document.addEventListener('visibilitychange',()=>{if(document.hidden)this.cancelDeployment?.(true);},{signal});
      const clamp=value=>Math.max(0,Math.min(1,value));
      const smooth=value=>{const t=clamp(value);return t*t*t*(t*(t*6-15)+10);};
      const out=value=>1-(1-clamp(value))**3;
      const mix=(a,b,t)=>a+(b-a)*t;
      const duration=mobile?1180:1450;
      const start=performance.now();
      const cameraScale=Math.max(1.14,innerHeight/stageRect.height*1.02);
      const frame=now=>{
        if(!this.isConnected){this.cancelDeployment?.();return;}
        if(this.reduce.matches||this.dataset.paused==='true'){this.cancelDeployment?.(true);return;}
        const t=clamp((now-start)/duration);
        const page=smooth((t-.06)/.62);
        this.gallery.style.setProperty('--arrival-labels',String(smooth((t-.82)/.14)));
        owner.scrollTo({top:mix(origin,destination,page),behavior:'instant'});
        const moved=owner.scrollTop-origin;
        const enter=smooth(t/.16);
        const exit=smooth((t-.69)/.31);
        const camera=smooth((t-.17)/.74);
        const door=smooth((t-.08)/.43);
        darkness.style.opacity=String(enter*(1-exit)*.98);
        space.style.opacity=String(enter*(1-smooth((t-.91)/.09)));
        space.style.transform=`translateY(${mix(innerHeight*.5-stageCenter,0,camera)}px) scale(${mix(cameraScale,1,camera)})`;
        halo.style.opacity=String(enter*(1-exit)*.65);
        halo.style.transform=`translate(-50%,-50%) scale(${.6+camera*.8})`;
        doors.forEach((element,i)=>{element.style.opacity=String(enter*(1-smooth((t-.57)/.15)));element.style.transform=`translateX(${(i?1:-1)*door*103}%)`;});
        structures.forEach((element,i)=>{
          element.style.opacity=String(enter*(1-smooth((t-.48-i*.05)/.25))*(i?.42:.82));
          element.style.transform=`perspective(1200px) translateZ(${mix(-170-i*170,650+i*50,out((t-.05)/.68))}px)`;
        });
        seam.style.opacity=String(smooth(t/.08)*(1-smooth((t-.18)/.28)));
        seam.style.transform=`translateX(-50%) scaleY(${mix(.12,1,out(t/.16))}) scaleX(${1+door*9})`;
        horizon.style.opacity=String(enter*(1-exit)*.5);
        horizon.style.transform=`translate(-50%,-50%) scaleX(${out((t-.04)/.35)})`;
        title.style.opacity=String(smooth((t-.16)/.12)*(1-smooth((t-.57)/.12))*.85);
        title.style.transform=`translate(-50%,${mix(12,0,out((t-.16)/.2))}px)`;
        tiles.forEach(tile=>{
          const delay=tile.chosen?0:.045+Math.abs(tile.rank)*.006;
          const emerge=smooth((t-delay)/.30);
          const travel=smooth((t-.47-Math.abs(tile.rank)*.003)/(.53-Math.abs(tile.rank)*.003));
          const ratio=sourceWidth/tile.width;
          const lift=Math.sin(emerge*Math.PI)*(mobile?24:55);
          const gx=mix(sourcePoint.x,tile.gx,emerge);
          const gy=mix(sourcePoint.y,tile.gy,emerge)-lift;
          const spreadScale=spreadWidth/tile.width*(1-Math.abs(tile.column)*.035);
          const scale=mix(mix(ratio*(tile.chosen?1:.68),spreadScale,emerge),tile.scale,travel);
          const ready=tile.image.complete&&tile.image.naturalWidth>0;
          if(ready&&tile.readyAt===undefined)tile.readyAt=t;
          const appear=tile.chosen?1:smooth((t-Math.max(delay,tile.readyAt??1))/.12);
          const opacity=appear*mix(1,tile.opacity,smooth((travel-.25)/.75));
          tile.tile.style.transform=`translate3d(${mix(gx,tile.x,travel)}px,${mix(gy,tile.y-moved,travel)}px,0) translate(-50%,-50%) scale(${scale})`;
          tile.tile.style.opacity=String(opacity);
          tile.shadow.style.opacity=String(Math.sin(Math.PI*emerge)*(1-travel)*.55);
          tile.beam.style.opacity=String(Math.sin(Math.PI*clamp((t-delay)/.64))*.13*(1-travel));
          tile.beam.style.transform=`translateX(${mix(-110,110,clamp((t-delay)/.64))}%)`;
          tile.object.style.transform=t===0&&tile.chosen?sourceTransform:`perspective(1600px) rotateX(${mix(mix(sourcePitch,22+Math.abs(tile.row)*7,emerge),tile.rx,travel)}deg) rotateY(${mix(mix(sourceYaw,-tile.column*3,emerge),tile.ry,travel)}deg) rotateZ(${mix(mix(mobile?-5:-6,-tile.column*1.5,emerge),tile.rz,travel)}deg)`;
        });
        if(t<1)this.deployFrame=requestAnimationFrame(frame);
        else this.cancelDeployment?.(true);
      };
      frame(start);
    }
    mod(value) { return ((value % this.series.length) + this.series.length) % this.series.length; }
    paint(announce = true) {
      if (!this.gallery || !this.series?.length) return;
      const width = this.orbitStage.clientWidth;
      this.mobile = window.innerWidth < 750;
      const n = this.series.length;
      const active = this.mod(Math.round(this.position));
      this.gallery.toggleAttribute('data-focus', this.focused);
      this.detail.inert = !this.focused;
      this.detail.setAttribute('aria-hidden', String(!this.focused));
      this.querySelector('[data-orbit-nav]').inert = this.focused;
      this.items.forEach((item, i) => {
        let d = ((i - this.position + n * 20 + n / 2) % n) - n / 2;
        const a = Math.abs(d);
        const chosen = i === active;
        const visible = this.focused ? chosen : a < (this.mobile ? 2 : 3);
        const x = this.focused ? chosen ? (this.mobile ? 0 : width * .2) : Math.sign(d || 1) * width * .85 : Math.sign(d) * width * (this.mobile ? Math.min(a,1) * .61 + Math.max(0,a-1)*.4 : Math.min(a,1) * .29 + Math.max(0,a-1) * .205);
        const scale = this.focused ? chosen ? (this.mobile ? 1.28 : 1.62) : .45 : Math.max(.32, 1.06 - a * .28);
        item.style.setProperty('--orbit-x', x.toFixed(2) + 'px');
        item.style.setProperty('--orbit-y', (this.focused ? (this.mobile ? -22 : -10) : -a * (this.mobile ? 10 : 18)).toFixed(2) + 'px');
        item.style.setProperty('--orbit-scale', scale.toFixed(3));
        item.style.setProperty('--orbit-opacity', visible ? 1 : 0);
        item.style.setProperty('--orbit-rx', (this.focused ? 48 : 38 + a * 3) + 'deg');
        item.style.setProperty('--orbit-ry', (this.focused ? -4 : Math.max(-22, Math.min(22, -d * 14))) + 'deg');
        item.style.setProperty('--orbit-rz', (this.focused ? -5 : -5 + Math.max(-8,Math.min(8,d*5))) + 'deg');
        item.style.setProperty('--orbit-z', this.focused ? chosen ? 10 : 1 : Math.round(10 - a));
        item.toggleAttribute('data-visible', visible);
        item.toggleAttribute('data-neighbor', !this.focused && a > .65 && a < 1.5);
        item.toggleAttribute('data-front', chosen);
        item.style.setProperty('--orbit-phase', `${i * -.6}s`);
        item.inert = !visible;
        item.setAttribute('aria-hidden', String(!visible));
        this.series[i].tabIndex = visible ? 0 : -1;
        this.tabs[i].setAttribute('aria-pressed', String(chosen));
        this.tabs[i].closest('.st-index-card').toggleAttribute('data-selected',chosen);
      });
      const card = this.series[active];
      this.querySelector('[data-orbit-name]').textContent = card.dataset.matName;
      this.querySelector('[data-orbit-mat-name]').textContent = card.dataset.seriesName;
      this.querySelector('[data-orbit-number]').textContent = String(active + 1).padStart(2,'0');
      if (announce) this.querySelector('[data-orbit-status]').textContent = card.dataset.seriesName + '. ' + card.dataset.matName;
    }
    browse(direction) {
      this.clearSelectionLight();      this.cancelDeployment?.();
      this.focused = false;
      this.position = Math.round(this.position) + direction;
      this.paint();
      this.warm(this.mod(Math.round(this.position)));
    }
    returnToBrowse() {
      this.clearSelectionLight();      this.focused = false;
      this.showImageError(false);
      this.paint();
      const target = this.series[this.mod(Math.round(this.position))];
      target.focus({preventScroll:true});
    }
    focusSeries(i, source) {
      this.cancelDeployment?.();
      this.returnFocus = source;
      this.position = i;
      this.activeSeries = i;
      this.focused = true;
      const card = this.series[i];
      this.refreshSeriesDetails(card, i);
      const image = card.querySelector('img');
      const thumbnail = this.tabs[i].querySelector('img');
      if ((!image.complete || !image.naturalWidth) && thumbnail.complete && thumbnail.naturalWidth) image.src = thumbnail.currentSrc || thumbnail.src;
      this.showImageError(card.dataset.failed === 'true');
      const tab = this.tabs[i];
      this.index.scrollTo({left:Math.max(0, tab.offsetLeft - this.index.offsetLeft - (this.index.clientWidth - tab.offsetWidth) / 2),behavior:'instant'});
      const rect = this.orbitStage.getBoundingClientRect();
      if (rect.top < -100 || rect.top > innerHeight * .7) this.gallery.scrollIntoView({block:'start',behavior:this.reduce.matches ? 'instant' : 'smooth'});
      if (source?.classList.contains('st-orbit-tab') && !this.reduce.matches && this.dataset.paused !== 'true') this.seedFromThumbnail(i, source);
      this.paint();
      this.back.focus({preventScroll:true});
      this.syncHero(card);
      this.warm(i);
      this.illuminateSelection(i);
    }
    refreshSeriesDetails(card, i) {
      this.querySelector('[data-detail-number]').textContent = String(i+1).padStart(2,'0');
      this.querySelector('[data-detail-series]').textContent = card.dataset.seriesName;
      this.querySelector('[data-detail-name]').textContent = card.dataset.matName;
      const link = this.querySelector('[data-detail-link]');
      link.href = card.dataset.link || this.sizesDestination || this.dataset.galleryDestination;
      this.querySelector('[data-detail-link-label]').textContent = card.dataset.productLink ? this.dataset.productLabel : card.dataset.link ? this.dataset.shopLabel : this.dataset.sizesLabel;
      this.querySelector('[data-mockup-open]').hidden = !card.closest('li').querySelector('template')?.content.querySelector('[data-mockup]');
      this.querySelector('[data-detail-commerce]').hidden = !card.dataset.productLink;
      this.querySelector('[data-detail-price]').textContent = card.dataset.price || '';
      this.querySelector('[data-detail-sizes]').textContent = card.dataset.sizeCount || '';
      const collectionLink = this.querySelector('[data-detail-collection]');
      collectionLink.hidden = !card.dataset.collectionLink;
      if (card.dataset.collectionLink) collectionLink.href = card.dataset.collectionLink;
      else collectionLink.removeAttribute('href');
      this.gallery.toggleAttribute('data-has-product',Boolean(card.dataset.productLink));
      const description = this.querySelector('[data-detail-description]');
      description.dataset.defaultText ||= description.textContent;
      description.textContent = card.dataset.description || description.dataset.defaultText;
    }
    initPalette(signal) {
      const source = this.querySelector('[data-palette-data]');
      if (!source) return;
      try { this.paletteProducts = JSON.parse(source.textContent); } catch { return; }
      this.paletteSeries = this.series.filter(card => card.dataset.paletteLinked === 'true');
      if (!this.paletteSeries.length) return;
      this.paletteButtons = [...this.querySelectorAll('[data-palette-color]')];
      this.paletteVersion = 0;
      this.activePalette = 'forest';
      this.paletteButtons.forEach(button => {
        const key = button.dataset.paletteColor;
        const rows = this.paletteRows(key);
        button.disabled = rows.length !== this.paletteSeries.length || rows.some(row => !row.preview) || new Set(rows.map(row => row.seriesId)).size !== this.paletteSeries.length;
        button.addEventListener('click', () => this.choosePalette(key), {signal});
        button.addEventListener('pointerenter', () => this.prefetchPalette(key), {signal});
        button.addEventListener('focus', () => this.prefetchPalette(key), {signal});
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const choices = this.paletteButtons.filter(choice => !choice.disabled);
          const current = choices.indexOf(button);
          const step = ['ArrowLeft','ArrowUp'].includes(event.key) ? -1 : 1;
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? choices.length - 1 : (current + step + choices.length) % choices.length;
          choices[next].focus({preventScroll:true});
          this.choosePalette(choices[next].dataset.paletteColor);
        }, {signal});
      });
      this.querySelector('[data-palette-controls]').hidden = false;
      const remembered = new URL(location.href).searchParams.get('st_color');
      if (remembered && this.paletteButtons.some(button => button.dataset.paletteColor === remembered && !button.disabled)) this.choosePalette(remembered, false);

    }
    paletteRows(key) {
      const ids = new Set(this.paletteSeries.map(card => card.dataset.seriesId));
      return this.paletteProducts.filter(row => row.colorKey === key && ids.has(row.seriesId)).sort((a,b) => a.seriesIndex - b.seriesIndex);
    }
    prefetchPalette(key) {
      if (navigator.connection?.saveData || navigator.connection?.effectiveType === '2g' || matchMedia('(pointer: coarse)').matches) return;
      this.paletteRows(key).forEach(row => this.load(row.preview));
    }
    async choosePalette(key, updateUrl = true) {
      const button = this.paletteButtons.find(choice => choice.dataset.paletteColor === key);
      if (!button || button.disabled || key === this.activePalette && !this.pendingPalette) return;
      const rows = this.paletteRows(key);
      const version = ++this.paletteVersion;
      this.pendingPalette = key;
      this.cancelDeployment?.();
      this.clearSelectionLight();
      const controls = this.querySelector('[data-palette-controls]');
      const status = this.querySelector('[data-palette-status]');
      controls.setAttribute('aria-busy','true');
      this.paletteButtons.forEach(choice => choice.toggleAttribute('data-pending', choice === button));
      const label = button.querySelector('[data-palette-label]').textContent;
      status.textContent = this.dataset.paletteLoading.replace('__COLOR__',label);
      const loaded = await Promise.all(rows.map(row => this.load(row.preview)));
      if (version !== this.paletteVersion || !this.isConnected) return;
      controls.removeAttribute('aria-busy');
      this.paletteButtons.forEach(choice => choice.removeAttribute('data-pending'));
      this.pendingPalette = null;
      if (loaded.some(image => !image)) {
        status.textContent = this.dataset.paletteError;
        return;
      }
      ++this.selectionVersion;
      rows.forEach((row, i) => {
        const cardIndex = this.series.findIndex(card => card.dataset.seriesId === row.seriesId);
        const card = this.series[cardIndex];
        Object.assign(card.dataset, {
          preview:row.preview, medium:row.medium, large:row.large, art:row.art,
          matName:row.name, productLink:row.link, link:row.link,
          collectionLink:row.collection, price:row.price, sizeCount:row.sizes,
          description:row.description, available:String(row.available), color:row.hex,
          crop:String(row.crop), loadedWidth:'600'
        });
        delete card.dataset.failed;
        card.href = row.link;
        const image = card.querySelector('.st-orbit-image');
        image.removeAttribute('srcset');
        image.src = loaded[i].src;
        image.alt = row.name;
        image.toggleAttribute('data-st-crop',row.crop);
        const tab = this.tabs[cardIndex];
        tab.setAttribute('aria-label',this.dataset.indexPreviewAction + ': ' + row.name + ', ' + card.dataset.seriesName);
        const thumb = tab.querySelector('img');
        thumb.src = loaded[i].src;
        thumb.toggleAttribute('data-st-crop',row.crop);
        tab.querySelector('.st-orbit-tab__art').textContent = row.name;
        tab.querySelector('.st-index-card__availability').textContent = row.available ? this.dataset.indexAvailable : this.dataset.indexUnavailable;
        const tile = tab.closest('.st-index-card');
        const price = tile.querySelector('.st-index-card__price');
        const sizes = document.createElement('small');
        sizes.textContent = row.sizes;
        price.replaceChildren(document.createTextNode(row.price),sizes);
        const shop = tile.querySelector('.st-index-card__shop');
        shop.href = row.link;
        shop.setAttribute('aria-label',this.dataset.indexShopAction + ': ' + row.name);
        const familyLink = tile.querySelector('.st-index-family-link');
        if (familyLink) familyLink.href = row.collection;
        const template = card.closest('li').querySelector('[data-mockup-set]');
        const frames = row.mockups.map(mockup => {
          const frame = document.createElement('span');
          frame.setAttribute('data-mockup','');
          const full = new URL(mockup[0],document.baseURI);
          full.searchParams.set('width','1600');
          frame.dataset.full = full.href;
          full.searchParams.set('width','160');
          frame.dataset.thumb = full.href;
          frame.dataset.alt = mockup[1] || row.name;
          return frame;
        });
        template.content.replaceChildren(...frames);
      });
      this.activePalette = key;
      this.paletteButtons.forEach(choice => {
        const selected = choice === button;
        choice.setAttribute('aria-checked',String(selected));
        choice.tabIndex = selected ? 0 : -1;
      });
      this.querySelector('[data-palette-selected]').textContent = label;
      this.style.setProperty('--st-palette-tone',rows[0].hex);
      this.paint(false);
      const activeCard = this.series[this.activeSeries];
      if (activeCard.dataset.paletteLinked === 'true') {
        this.refreshSeriesDetails(activeCard,this.activeSeries);
        await this.syncHero(activeCard);
      }
      if (version !== this.paletteVersion || !this.isConnected) return;
      if (!this.reduce.matches && this.dataset.paused !== 'true') {
        this.paletteSeries.forEach((card,i) => {
          const sheen = card.querySelector('.st-orbit-sheen');
          sheen.getAnimations().forEach(animation => animation.cancel());
          sheen.animate([{transform:'translateX(-145%) skewX(-16deg)',opacity:0},{opacity:.32,offset:.35},{transform:'translateX(145%) skewX(-16deg)',opacity:0}],{duration:650,delay:i*18,easing:'ease-out'});
        });
      }
      status.textContent = this.dataset.paletteReady.replace('__COLOR__',label);
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('st_color',key);
        history.replaceState(history.state,'',url);
      }
    }
    clearSelectionLight() {
      this.lightVersion = (this.lightVersion || 0) + 1;
      this.lightAnimations?.forEach(animation => animation.cancel());
      this.lightAnimations = [];
      this.lightItem?.removeAttribute('data-lit');
      this.gallery?.removeAttribute('data-lighting');
      this.lightItem = null;
    }
    illuminateSelection(i) {
      this.clearSelectionLight();
      if (this.reduce.matches || this.dataset.paused === 'true' || document.hidden || !this.focused) return;
      const item = this.items[i];
      const card = this.series[i];
      const source = card.querySelector('.st-orbit-image');
      if (!source.complete || !source.naturalWidth) return;
      const object = item.querySelector('.st-orbit-object');
      this.gallery.style.setProperty('--vault-tone', card.dataset.color || '#264833');
      this.lightItem = item;
      item.setAttribute('data-lit','');
      this.gallery.setAttribute('data-lighting','');
      const version = this.lightVersion;
      const duration = 1800;
      const animate = (target,frames,options = {}) => {
        if (!target) return;
        const animation = target.animate(frames.map(frame => ({...frame,easing:'cubic-bezier(.22,.7,.25,1)'})),{duration,easing:'linear',...options});
        this.lightAnimations.push(animation);
        return animation;
      };
      const envelope = peak => [
        {opacity:0,offset:0},
        {opacity:peak*.12,offset:.14},
        {opacity:peak,offset:.36},
        {opacity:peak*.72,offset:.57},
        {opacity:0,offset:1}
      ];
      const lift = animate(item.querySelector('.st-orbit-float'),[
        {transform:'translate3d(0,0,0)',offset:0},
        {transform:'translate3d(0,-5px,0)',offset:.28},
        {transform:'translate3d(0,-3px,0)',offset:.55},
        {transform:'translate3d(0,0,0)',offset:1}
      ]);
      animate(object.querySelector('.st-orbit-sheen'),[
        {transform:'translate3d(-145%,0,0) skewX(-16deg)',opacity:0,offset:0},
        {transform:'translate3d(-105%,0,0) skewX(-16deg)',opacity:.15,offset:.18},
        {transform:'translate3d(15%,0,0) skewX(-16deg)',opacity:.5,offset:.46},
        {transform:'translate3d(150%,0,0) skewX(-16deg)',opacity:0,offset:.77},
        {transform:'translate3d(150%,0,0) skewX(-16deg)',opacity:0,offset:1}
      ]);
      animate(object.querySelector('.st-orbit-edge-light'),envelope(.32));
      animate(item.querySelector('.st-orbit-aura'),envelope(.18));
      animate(this.querySelector('.st-vault-activation-light'),envelope(.42));
      animate(this.querySelector('.st-vault-activation-floor'),envelope(.28));
      const details = [...this.detail.children].filter(element => !element.hidden);
      details.forEach((element,index) => animate(element,[
        {opacity:0,transform:'translateY(9px)'},
        {opacity:1,transform:'translateY(0)'}
      ],{duration:460,delay:Math.min(index,5)*45+130,fill:'backwards'}));
      lift?.finished.then(() => {
        if (version === this.lightVersion) this.clearSelectionLight();
      }).catch(() => {});
    }
    seedFromThumbnail(i, source) {
      const item = this.items[i];
      const object = item.querySelector('.st-orbit-object');
      const stage = this.orbitStage.getBoundingClientRect();
      const thumb = source.querySelector('img').getBoundingClientRect();
      const baseWidth = item.offsetWidth;
      const centerX = Math.max(stage.left + 30, Math.min(stage.right - 30, thumb.left + thumb.width / 2));
      const centerY = Math.min(stage.bottom - 20, thumb.top + thumb.height / 2);
      item.style.transition = 'none';
      object.style.transition = 'none';
      item.style.setProperty('--orbit-x', (centerX - stage.left - stage.width / 2) + 'px');
      item.style.setProperty('--orbit-y', (centerY - stage.top - item.offsetTop - item.offsetHeight / 2) + 'px');
      item.style.setProperty('--orbit-scale', String(Math.max(.12, thumb.width / baseWidth)));
      item.style.setProperty('--orbit-opacity', '1');
      item.style.setProperty('--orbit-rx', '0deg');
      item.style.setProperty('--orbit-ry', '0deg');
      item.style.setProperty('--orbit-rz', '0deg');
      item.style.setProperty('--orbit-z', '10');
      item.getBoundingClientRect();
      item.style.removeProperty('transition');
      object.style.removeProperty('transition');
    }
    highRes(card) {
      const item = card.closest('.st-orbit-item');
      const targetWidth = Math.max(item.offsetWidth * (innerWidth < 750 ? 1.28 : 1.62), this.stage.clientWidth);
      const pixels = Math.ceil(targetWidth * Math.min(devicePixelRatio || 1, 3));
      return pixels <= 900 ? card.dataset.medium : pixels <= 1500 ? card.dataset.large : card.dataset.art;
    }
    warm(i) {
      if (navigator.connection?.saveData || navigator.connection?.effectiveType === '2g') return;
      const card = this.series[i];
      if (!card) return;
      const url = this.highRes(card);
      const width = Number(new URL(url, document.baseURI).searchParams.get('width')) || 2000;
      this.load(url).then(image => {
        if (!image || !this.isConnected || url !== this.highRes(card) || width < Number(card.dataset.loadedWidth || 0)) return;
        card.dataset.loadedWidth = String(width);
        card.querySelector('.st-orbit-image').src = image.src;
        const traceImage = card.querySelector('.st-orbit-trace img');
        if (traceImage) traceImage.src = image.src;
        if (this.activeSeries === i && this.heroCard === card) this.art.src = image.src;
      });
    }
    load(url) {
      if (this.cache.has(url)) return this.cache.get(url);
      const promise = new Promise(resolve => {
        const image = new Image();
        image.decoding = 'async';
        let done = false;
        const finish = value => {
          if (done) return;
          done = true;
          clearTimeout(timer);
          this.loadTimers.delete(timer);
          if (!value) this.cache.delete(url);
          resolve(value);
        };
        const timer = setTimeout(() => finish(null), 12000);
        this.loadTimers.add(timer);
        image.onload = () => image.decode().then(() => finish(image), () => finish(image));
        image.onerror = () => finish(null);
        image.src = url;
      });
      this.cache.set(url, promise);
      return promise;
    }
    async syncHero(card) {
      if (!this.art) return;
      const version = ++this.selectionVersion;
      const source = card.querySelector('img');
      let url = source.complete && source.naturalWidth ? source.currentSrc || source.src : '';
      if (!url) {
        const thumb = this.tabs[this.series.indexOf(card)].querySelector('img');
        if (thumb.complete && thumb.naturalWidth) url = thumb.currentSrc || thumb.src;
      }
      this.querySelector('[data-st-error]').textContent = '';
      if (!url) {
        this.stage.setAttribute('aria-busy','true');
        const preview = await this.load(card.dataset.preview);
        if (version !== this.selectionVersion || !this.isConnected) return;
        if (!preview) {
          this.stage.removeAttribute('aria-busy');
          this.querySelector('[data-st-error]').textContent = this.dataset.errorLabel;
          return;
        }
        url = preview.src;
      }
      if (version !== this.selectionVersion || !this.isConnected) return;
      this.heroCard = card;
      this.art.removeAttribute('srcset');
      this.art.src = url;
      this.art.alt = card.dataset.matName;
      this.art.toggleAttribute('data-st-crop', card.dataset.crop === 'true');
      this.style.setProperty('--st-ratio',card.dataset.ratio || '2');
      this.style.setProperty('--st-chip',card.dataset.color || '#264833');
      this.querySelector('[data-st-name]').textContent = card.dataset.matName;
      this.querySelector('[data-st-series]').textContent = card.dataset.seriesName;
      this.querySelector('[data-st-cta]').href = card.dataset.productLink || this.dataset.galleryDestination;
      this.querySelector('[data-st-cta-label]').textContent = card.dataset.productLink ? this.dataset.productLabel : this.dataset.exploreLabel;
      this.stage.removeAttribute('aria-busy');
      this.querySelector('[data-st-status]').textContent = card.dataset.seriesName + '. ' + card.dataset.matName;
      this.angle.getAnimations().forEach(animation => animation.cancel());
      if (!this.reduce.matches && this.dataset.paused !== 'true') {
        const base = getComputedStyle(this.angle).transform;
        this.angle.animate([{transform:base+' translateY(-7px)',opacity:1},{transform:base,opacity:1}],{duration:440,easing:'cubic-bezier(.2,.8,.2,1)'});
      }
      this.warm(this.series.indexOf(card));
    }
    initLookbook(signal) {
      this.lookbook = this.querySelector('[data-lookbook]');
      const close = () => this.lookbook.close();
      this.querySelector('[data-mockup-open]').addEventListener('click', event => this.openLookbook(event.currentTarget), {signal});
      this.lookbook.querySelector('[data-lookbook-close]').addEventListener('click', close, {signal});
      this.lookbook.addEventListener('click', event => { if (event.target === this.lookbook) { const r = this.lookbook.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } }, {signal});
      this.lookbook.addEventListener('close', () => {
        if (this.lookbookOwner) this.lookbookOwner.style.overflow = this.lookbookOverflow;
        this.lookbookReturn?.focus({preventScroll:true});
      }, {signal});
      const photo = this.lookbook.querySelector('[data-lookbook-photo]');
      photo.addEventListener('click', () => {
        const zoom = photo.getAttribute('aria-pressed') !== 'true';
        photo.setAttribute('aria-pressed', String(zoom));
        photo.scrollTo(0,0);
      }, {signal});
      this.lookbook.addEventListener('keydown', event => {
        if ((event.key === 'ArrowRight' || event.key === 'ArrowLeft') && photo.getAttribute('aria-pressed') !== 'true') {
          event.preventDefault();
          this.showMockup((this.mockupIndex+(event.key==='ArrowRight'?1:-1)+this.mockupSources.length)%this.mockupSources.length);
        }
      }, {signal});
      this.lookbook.querySelector('[data-lookbook-link]').addEventListener('click', () => { if (!this.series[this.activeSeries].dataset.productLink) close(); }, {signal});
    }
    openLookbook(trigger) {
      const card = this.series[this.activeSeries];
      this.mockupSources = Array.from(card.closest('li').querySelector('template')?.content.querySelectorAll('[data-mockup]') || []);
      if (!this.mockupSources.length) return;
      this.clearSelectionLight();
      this.lookbookReturn = trigger;
      this.lookbook.querySelector('[data-lookbook-name]').textContent = card.dataset.matName;
      this.lookbook.querySelector('[data-lookbook-series]').textContent = card.dataset.seriesName;
      this.lookbook.querySelector('[data-lookbook-description]').textContent = card.dataset.description || this.querySelector('[data-detail-description]').textContent;
      const link = this.lookbook.querySelector('[data-lookbook-link]');
      link.href = card.dataset.productLink || this.sizesDestination || this.dataset.galleryDestination;
      link.querySelector('span').textContent = card.dataset.productLink ? this.dataset.productLabel : this.dataset.sizesLabel;
      const price = this.lookbook.querySelector('[data-lookbook-price]');
      price.textContent = card.dataset.price || '';
      price.hidden = !card.dataset.price;
      const thumbs = this.lookbook.querySelector('[data-lookbook-thumbs]');
      thumbs.replaceChildren();
      this.mockupSources.forEach((source,i) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label',source.dataset.alt);
        button.setAttribute('aria-pressed','false');
        const image = document.createElement('img');
        image.src = source.dataset.thumb;
        image.alt = '';
        image.width = 100;
        image.height = 100;
        image.loading = 'lazy';
        button.append(image);
        button.addEventListener('click', () => this.showMockup(i));
        thumbs.append(button);
      });
      this.showMockup(0);
      this.lookbookOwner = this.scrollOwner();
      this.lookbookOverflow = this.lookbookOwner.style.overflow;
      this.lookbookOwner.style.overflow = 'hidden';
      this.lookbook.showModal();
      this.lookbook.querySelector('[data-lookbook-close]').focus({preventScroll:true});
    }
    showMockup(i) {
      this.mockupIndex = i;
      const source = this.mockupSources[i];
      const image = this.lookbook.querySelector('[data-lookbook-image]');
      image.src = source.dataset.full;
      image.alt = source.dataset.alt;
      const photo = this.lookbook.querySelector('[data-lookbook-photo]');
      photo.setAttribute('aria-pressed','false');
      photo.scrollTo(0,0);
      Array.from(this.lookbook.querySelector('[data-lookbook-thumbs]').children).forEach((button,index) => button.setAttribute('aria-pressed',String(index===i)));
      this.lookbook.querySelector('[data-lookbook-status]').textContent = `${i+1} / ${this.mockupSources.length}`;
    }

    showImageError(show) { this.querySelector('[data-orbit-error]').hidden = !show; }
    disconnectedCallback() {
      if (this.lookbook?.open) this.lookbook.close();
      if (this.lookbookOwner) this.lookbookOwner.style.overflow = this.lookbookOverflow;
      this.paletteVersion = (this.paletteVersion || 0) + 1;
      clearTimeout(this.palettePrefetchTimer);
      this.clearSelectionLight();      this.cancelDeployment?.();
      this.galleryObserver?.disconnect();
      cancelAnimationFrame(this.settleFrame);
      this.gallery?.removeAttribute('data-deploy-settled');
      this.controller?.abort();
      this.observer?.disconnect();
      this.previewObserver?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.orbitFrame);
      this.loadTimers?.forEach(timer => clearTimeout(timer));
      this.angle?.getAnimations().forEach(animation => animation.cancel());
      this.index?.replaceChildren();
    }
  });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["surfacetheory-proportions"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('surface-proportions')) {
  customElements.define('surface-proportions',class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller=new AbortController();
      this.options=Array.from(this.querySelectorAll('[data-size]'));
      this.units=Array.from(this.querySelectorAll('[data-unit]'));
      this.unit='in';
      this.selected=this.options.find(button=>button.getAttribute('aria-pressed')==='true')||this.options[0];
      this.options.forEach(button=>button.addEventListener('click',()=>{this.selected=button;this.updateSize(true);},{signal:this.controller.signal}));
      this.units.forEach(button=>button.addEventListener('click',()=>{this.unit=button.dataset.unit;this.updateSize(true);},{signal:this.controller.signal}));
      this.updateSize();
    }
    updateSize(announce=false) {
      const factor=this.unit==='cm'?2.54:1;
      const number=value=>(Number(value)*factor).toFixed(1);
      this.options.forEach(button=>{
        button.setAttribute('aria-pressed',String(button===this.selected));
        button.querySelector('[data-dimensions]').textContent=number(button.dataset.width)+' × '+number(button.dataset.height);
        button.querySelector('[data-size-unit]').textContent=this.unit;
      });
      this.units.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.unit===this.unit)));
      const width=this.selected.dataset.width,height=this.selected.dataset.height;
      const mat=this.querySelector('[data-size-mat]');
      mat.style.width=(Number(width)/31.5*100)+'%';
      mat.style.height=(Number(height)/15.5*100)+'%';
      this.querySelector('[data-study-width]').textContent=number(width)+' '+this.unit;
      this.querySelector('[data-study-height]').textContent=number(height)+' '+this.unit;
      const name=this.selected.querySelector('strong').textContent;
      this.querySelector('[data-size-name]').textContent=name;
      this.querySelector('[data-size-index]').textContent=String(this.options.indexOf(this.selected)+1).padStart(2,'0');
      if(announce)this.querySelector('[data-size-status]').textContent=name+'. '+number(width)+' × '+number(height)+' '+this.unit;
    }
    disconnectedCallback(){this.controller?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
